export enum UserGroupTabValues {
  User = 'user',
  Group = 'group',
}
